export default "__VITE_ASSET__W280XhXm__"